@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.root {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.description {
  flex: 1 0 0;
  min-width: 0;
  @include typography-v2-title-sm;
  color: var(--text-default);
}

.pill {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 8px;
  flex-shrink: 0;
  white-space: nowrap;
  @include border-radius-r1;

  &.negative {
    background-color: var(--viz-bearish-soft);
  }

  &:not(.negative) {
    background-color: var(--viz-bullish-soft);
  }
}

.horizonLabel {
  @include typography-v2-ui-xs;
  color: var(--text-default);
}

.returnValue {
  @include typography-v2-ui-sm;
  font-family: var(--font-roboto-mono);

  &.negative {
    color: var(--viz-bearish);
  }

  &:not(.negative) {
    color: var(--viz-bullish);
  }
}
